export default __webpack_public_path__ + "static/media/collpase-icon.a0bdefb5.svg";